<template>

<div class="colourpicker" v-bind:class="{'is-disabled': disabled}">

	<div v-if="title" class="colourpicker-title"><span>{{ title }}</span></div>

	<div class="colourpicker-defaults" :class="{'is-text': isText}">

		<div class="colourpicker-defaults-item" v-for="(color, index) in defaults" :key="index" :style="{backgroundColor: color}" :class="{'is-selected': selected === color}" v-on:click="onColorClick(color)">

			<i class="fa fa-check" v-if="selected === color"></i>

		</div>

	</div>

	<div class="colourpicker-manual">
	
		<div class="colourpicker-manual-prefix">#</div>
		<input type="text" placeholder="Enter hex code..." maxlength="6" v-on:keypress="onKeyPress" v-model="hexText" class="colourpicker-manual-text" />
		<div class="colourpicker-manual-colour" :style="{backgroundColor: selected}" />

	</div>

</div>

</template>

<script>

import InputValidation from 'core/mixin/form/input/Validation.js'

export default {

	mixins: [InputValidation],

	props: [
		'title',
		'name',
		'value',
		'disabled',
		'error',
		'validation',
		'isText'
	],

	data: function() {

		return {
			hexText: '',
			selected: false
		}

	},

	created: function() {

		this.selected = (this.value) ? this.value : '#134677'

	},

	watch: {

		hexText: function(n) {

			if (n.length === 6) this.selected = '#' + n
			this.$emit('input', this.selected)

		},

		selected: function(n) {

			this.hexText = n.replace('#', '')

		}

	},

	computed: {

		defaults: function() {

			if(this.isText) {

				return [
					'#000000', '#222222', '#666666', '#ffffff'
				]

			} else {

				return [
					// Row 1 — Blues
					'#134677', '#3974ad', '#4986c1', '#78aadc',
					'#0f355c', '#1f5f96', '#3d6f97', '#7fa7c9',

					// Row 2 — Greens & Teals
					'#136712', '#239022', '#37a536', '#65ca63',
					'#0f4d4f', '#1f7d80', '#41a8ab', '#7eced0',

					// Row 3 — Reds & Warm Accents
					'#802314', '#a53220', '#b74533', '#c76859',
					'#7a3609', '#c75a16', '#e58b47', '#f3bc8e',

					// Row 4 — Golds & Purples
					'#6a5204', '#a78008', '#d6ae38', '#f4d98b',
					'#6c20a5', '#9c56d0', '#bea6e4', '#d7659e',

					// Row 5 — Soft Reds & Neutrals
					'#ef9a9c', '#681746', '#d65c60', '#ef9ec5',
					'#000000', '#333333', '#777777', '#999999'
				]

			}

		}

	},

	methods: {

		onKeyPress: function(e) {

			if(!this.$_.contains([
				'a','b','c','d','e','f','1','2','3','4','5','6','7','8','9','0','backspace'
			], e.key.toString().toLowerCase())) {

				e.preventDefault()

			}

		},

		onColorClick: function(value) {

			this.selected = value
			this.$emit('input', value)

		},

		validate: function(rules) {

			if (rules.exists) {

				if (this.value === false) {

					this.feedback.push('required')

				}

			}

		}

	}

}

</script>

<style scoped>

.colourpicker {
	margin-bottom: 15px;
	overflow: hidden;
}

.colourpicker.is-disabled {
	opacity: 0.25;
	pointer-events: none;
}

.colourpicker-title {
	color: #fff;
	font-size: 16px;
	height: 8px;
	font-weight: 500;
	margin-bottom: 22px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}

.is-mobile .colourpicker-title {
	border-bottom: 1px solid #eee;
}

.colourpicker-title span {
	background-color: #2b5870;
	min-width: 80px;
	padding-right: 15px;
	display: inline-block;
}

.is-mobile .colourpicker-title span {
	background-color: #fff;
	color: #343434;
}

.colourpicker-defaults {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
	flex-wrap: wrap;
	grid-gap: 2px;
}

.colourpicker-defaults.is-text {
	grid-template-columns: 1fr 1fr 1fr 1fr;
}

.colourpicker-defaults-item {
	height: 32px;
	line-height: 32px;
	border-radius: 4px;
	text-align: center;
	font-size: 14px;
	cursor: pointer;
	color: #fff;
	font-weight: 400px;
	border: 2px solid transparent;
}

.colourpicker-defaults-item:hover {
	border: 2px solid #fff;
}

.colourpicker-defaults-item:nth-child(4n) {
	margin-right: 0px;
}

.colourpicker-manual {
	display: grid;
	grid-template-columns: 32px 1fr 40px;
	background-color: #fff;
	border: 2px solid #fff;
	border-radius: 4px;
	margin-top: 8px;
}

.is-mobile .colourpicker-manual {
	border: 2px solid #eee;
}

.colourpicker-manual-prefix {
	text-align: center;
	font-size: 16px;
	line-height: 40px;
}

.colourpicker-manual-text {
	height: 40px;
	line-height: 40px;
	font-size: 16px;
	font-weight: 400;
	padding: 8px;
	width: 100%;
	flex-grow: 1;
	color: #333;
}

.is-mobile .colourpicker-manual-text {
	font-size: 14px;
}

.colourpicker-manual-colour {
	border-radius: 4px;
}

</style>
